import { tagColor } from '../lib/tags';

export function Tag({ children, onClick, active }: { children: string; onClick?: () => void; active?: boolean }) {
  const { bg, text } = tagColor(children);
  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className="chip transition hover:brightness-95"
        style={
          active
            ? { background: text, color: 'white' }
            : { background: bg, color: text }
        }
      >
        {children}
      </button>
    );
  }
  return (
    <span className="chip" style={{ background: bg, color: text }}>
      {children}
    </span>
  );
}
